import { render, staticRenderFns } from "./updateDeleteBtnDynamic.vue?vue&type=template&id=0c6ea430&"
import script from "./updateDeleteBtnDynamic.vue?vue&type=script&lang=js&"
export * from "./updateDeleteBtnDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports